type TValorantmaps =
|'abyss'
|'ascent'
|'bind'
|'breeze'
|'fracture'
|'haven'
|'icebox'
|'lotus'
|'pearl'
|'split'
|'sunset'
;
const ValorantmapsNS = 'valorantmaps';
function ValorantmapsF(_: TValorantmaps): string { return `${ValorantmapsNS}:${_}`; }
export {TValorantmaps,ValorantmapsF,ValorantmapsNS};
